import * as tslib_1 from "tslib";
import { setSearchTerm, getSearchResults, getQuery } from 'owa-options-search';
import { observer } from 'mobx-react';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import OptionSearchSuggestion from './OptionSearchSuggestion';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
var styles = require('./OptionsFull.scss');
var FullOptionSearch = /** @class */ (function (_super) {
    tslib_1.__extends(FullOptionSearch, _super);
    function FullOptionSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSearchBoxKeyDown = function (ev) {
            if (ev.key === 'ArrowDown') {
                _this.suggestionFocusZone.focus();
                ev.stopPropagation();
                ev.preventDefault();
            }
        };
        _this.onFirstOptionKeyDown = function (ev) {
            switch (ev.key) {
                case 'ArrowUp':
                    if (ev.currentTarget.dataset.optionIndex === '0') {
                        _this.searchBox.focus();
                        break;
                    }
                    else {
                        return;
                    }
                case 'Escape':
                    setSearchTerm('');
                    _this.searchBox.focus();
                    break;
                default:
                    // don't stop propagation or prevent default
                    return;
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this.searchBoxRef = function (ref) {
            _this.searchBox = ref;
            _this.searchBoxElement = ReactDOM.findDOMNode(ref);
        };
        _this.suggestionFocusZoneRef = function (ref) {
            _this.suggestionFocusZone = ref;
        };
        return _this;
    }
    FullOptionSearch.prototype.render = function () {
        var _this = this;
        var suggestedOptions = getSearchResults();
        var showSuggestions = suggestedOptions && suggestedOptions.length > 0;
        return (React.createElement("div", { onKeyDown: showSuggestions ? this.onSearchBoxKeyDown : undefined },
            React.createElement(SearchBox, { componentRef: this.searchBoxRef, labelText: strings.optionsFull_searchPlaceholder, className: styles.searchBox, value: getQuery(), onChanged: setSearchTerm }),
            getQuery().trim().length > 0 && (React.createElement(Callout, { target: this.searchBoxElement, isBeakVisible: false, className: styles.suggestionCallout }, showSuggestions ? (React.createElement(FocusZone, { direction: FocusZoneDirection.vertical, componentRef: this.suggestionFocusZoneRef }, suggestedOptions.map(function (option, index) { return (React.createElement(OptionSearchSuggestion, { key: option.key, option: option, onKeyDown: _this.onFirstOptionKeyDown, "data-option-index": index })); }))) : (React.createElement(CommandButton, { className: styles.noSuggestions, disabled: true, text: strings.optionsFull_search_noResults }))))));
    };
    FullOptionSearch = tslib_1.__decorate([
        observer
    ], FullOptionSearch);
    return FullOptionSearch;
}(React.Component));
export default FullOptionSearch;
//# sourceMappingURL=FullOptionSearch.js.map